import { useEffect, useState } from 'react';

import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import CallWithRole from '../hoc/callWithRole';
import { useAppSelector } from '../redux/hooks';
import { joinLiveClassState } from '../redux/liveClass/joinLiveClass.slices';
import LiveClass from '../domain/services/bbb/meeting/Index';

function UseLiveClassDetails() {
  const history = useHistory();
  const { classDetails } = useAppSelector(joinLiveClassState);
  const { t } = useTranslation('live_classes');
  const [classEnd, setClassEnd] = useState(`00:00 ${t('until end')}`);
  const [isClassRunning, setIsClassRunning] = useState(true);
  const [details, setDetails] = useState({
    starting_at: null,
    name: '',
    duration: 0,
    description: '',
    status: null,
  });

  useEffect(() => {
    if (classDetails.loading === 'success') {
      setDetails(classDetails.response.live_classes_by_pk);
    }
  }, [classDetails]);

  function howMuchTillEnd() {
    if (!details) {
      return null;
    }
    const ends = DateTime.fromISO(details.starting_at).plus({ minutes: details.duration });
    const now = DateTime.now();
    return ends.diff(now, 'minutes');
  }

  function checkClassStatus(): boolean {
    if (!details) {
      return null;
    }
    if (howMuchTillEnd().toObject().minutes <= 0) {
      setIsClassRunning(false);
    }
    if (details.status === 'Ended') {
      setIsClassRunning(false);
    }
  }

  function getTillEndInMinutes() {
    const timeTillEnd = howMuchTillEnd();
    if (!timeTillEnd) {
      return;
    }
    let untilEnd = `00:00 ${t('until end')}`;

    if (timeTillEnd.minutes) {
      // eslint-disable-next-line quotes
      untilEnd = `${timeTillEnd.toFormat(`mm:ss`)} ${t('until end')}`;
    }
    setClassEnd(untilEnd);
  }

  useEffect(() => {
    let interval = null;

    interval = setInterval(() => {
      checkClassStatus();
      getTillEndInMinutes();
    }, 1000);

    return () => clearInterval(interval);
  }, [classEnd, details]);

  async function teacherEndClass(id) {
    await new LiveClass().teacherDeleteMeeting({ lesson_id: id });
    history.push('/live');
  }

  function studentEndClass() {
    history.push('/live');
  }

  const endVideo = CallWithRole({
    teacher: teacherEndClass,
    student: studentEndClass,
  });

  return {
    isClassRunning,
    details,
    classEnd,
    endVideo,
    getTillEndInMinutes,
  };
}

export default UseLiveClassDetails;
